import { render, staticRenderFns } from "./PatientCommunication.vue?vue&type=template&id=7ca610d1"
import script from "./PatientCommunication.vue?vue&type=script&lang=js"
export * from "./PatientCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports